/**
 * Chain icons — derived from @b3/chain-registry (single source of truth).
 * Priority: TrustWallet slug → registry logoUrl → chainlistapi icon.
 * To add chain icons, edit "trustwalletSlug" or "logoUrl" in chains.json.
 */
import { TRUSTWALLET_SLUGS, LOGO_URLS } from "@b3/chain-registry";

const TRUSTWALLET_ICON_MAP: Record<number, string> = {
  ...TRUSTWALLET_SLUGS,
  420: "optimism",
};

export function getChainIconUrl(chainId: number): string | null {
  const slug = TRUSTWALLET_ICON_MAP[chainId];
  if (slug) {
    return `https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/${slug}/info/logo.png`;
  }
  return LOGO_URLS[chainId] ?? null;
}

export function resolveChainIconUrl(chainId: number, chainlistIconUrl?: string | null): string | null {
  const registryIcon = getChainIconUrl(chainId);
  if (registryIcon) return registryIcon;

  if (typeof chainlistIconUrl === "string" && chainlistIconUrl.startsWith("/")) {
    return `https://chainlistapi.com${chainlistIconUrl}`;
  }

  return chainlistIconUrl || null;
}
